<script setup lang="ts">
// @ts-ignore
import { onBeforeUnmount, onMounted, onUnmounted, ref } from 'vue';
import i18n from '@/localization/i18n';

const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL

const ImagePresent = VITE_ASSET_URL + 'assets/public/assets/img/ps/present.webp'
const ImageCheck = VITE_ASSET_URL + 'assets/public/assets/img/ps/ps-check.webp'

// Local variables
const t = i18n.global.t
const screenSize = ref(0)

onMounted(() => {
  handleResize()
  window.addEventListener('resize', handleResize);
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

const handleResize = () => {
  screenSize.value = window.innerWidth
};
</script>

<template>
  <section class="py-5 bg-white">
    <div class="container">

      <!-- Titre -->
      <div class="text-center mb-5">
        <h2 class="fw-semibold">
          {{ t("w_txt_psOffer_title") }} <strong>{{ t("w_txt_psOffer_title_bold") }}</strong>
        </h2>
        <p class="text-muted mt-2">
          {{ t("w_txt_psOffer_subtitle") }}
        </p>
        <p class="mb-2">
       <strong>{{ t("w_txt_psOffer_summary_bold") }}</strong>,
        {{ t("w_txt_psOffer_summary_continued") }}
      </p>
      </div>

      <!-- Cartes -->
      <div class="row g-4 justify-content-center align-items-stretch">
        <!-- Carte Pro -->
        <div class="col-lg-4">
          <div class="h-100 p-4 rounded-4 border bg-light">

            <h3 class="fw-semibold mb-1">{{ t("w_txt_psOffer_free_plan") }}</h3>
            <div class="display-5 fw-bold mb-3">
              {{ t("w_txt_psOffer_free_price") }}
              <span class="fs-5 fw-normal">{{ t("w_txt_psOffer_free_price_period") }}</span>
            </div>

            <ul class="list-unstyled mb-4">
              <li>{{ t("w_txt_psOffer_free_plan_features_01") }}</li>
              <li>{{ t("w_txt_psOffer_free_plan_features_02") }}</li>
              <li>{{ t("w_txt_psOffer_free_plan_features_03") }}</li>
              <li>{{ t("w_txt_psOffer_free_plan_features_04") }}</li>
              <li>{{ t("w_txt_psOffer_free_plan_features_05") }}</li>
              <li>{{ t("w_txt_psOffer_free_plan_features_06") }}</li>
            </ul>

            <a class="btn btn-info bg-dark-blue rounded w-100 py-2 mb-3" href="/ps/home/" target="_blank">
              {{ t("w_txt_psOffer_free_plan_button") }}
            </a>

            <div class="text-center">
              <small>
                {{ t("w_txt_psOffer_free_plan_description") }} <br><br>

              </small>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="h-100 p-4 rounded-4 border bg-light">

            <h3 class="fw-semibold mb-1">{{ t("w_txt_psOffer_pro_plan") }}</h3>
            <div class="display-5 fw-bold mb-3">
              {{ t("w_txt_psOffer_pro_price") }} <span class="fs-5 fw-normal">{{ t("w_txt_psOffer_free_price_period")
                }}</span>
            </div>

            <ul class="list-unstyled mb-4">
              <li>{{ t("w_txt_psOffer_pro_plan_features_01") }}</li>
              <li>{{ t("w_txt_psOffer_pro_plan_features_02") }}</li>
              <li>{{ t("w_txt_psOffer_pro_plan_features_03") }}</li>
              <li>{{ t("w_txt_psOffer_pro_plan_features_04") }}</li>
              <li>{{ t("w_txt_psOffer_pro_plan_features_05") }}</li>
              <li>{{ t("w_txt_psOffer_pro_plan_features_06") }}</li>
            </ul>

            <a class="btn btn-info rounded w-100 py-2 mb-3" href="/ps/home/" target="_blank">
              {{ t("w_txt_psOffer_pro_plan_button") }}
            </a>

            <div class="text-center">
              <span class="badge bg-light-success fs-6 ">
                {{ t("w_txt_psOffer_pro_plan_description") }}
              </span>
            </div>
          </div>
        </div>


      </div>

      <!-- table of features -->
      <div class="text-center mt-5">


        <a class="btn btn-outline-info text-info rounded px-5 py-3 fw-semibold" data-bs-toggle="collapse" href="#featuresTable" role="button"
          aria-expanded="false" aria-controls="featuresTable">
          {{ t("w_txt_psOffer_show_features_table") }}
        </a>
        <div class="collapse mt-4" id="featuresTable">
          <div class="border-0 shadow-sm rounded-4 p-3">

            <!-- TABLEAU -->
            <div class="table-responsive">
              <table class="table align-middle table-bordered">
                <thead class="table-light">
                  <tr>
                    <th style="min-width: 420px;"></th>
                    <th class="text-center">{{ t("w_txt_psOffer_table_logged") }}<br><small>{{
                      t("w_txt_home_infoappRegistrationFree") }}</small></th>
                    <th class="text-center">{{ t("w_txt_psOffer_table_pro") }}<br><small>{{ t("w_txt_psOffer_pro_price")
                        }} {{ t("w_txt_psOffer_free_price_period") }}</small></th>
                  </tr>
                </thead>

                <tbody>

                  <!-- ================= Visibilité & demandes ================= -->
                  <tr class="table-secondary">
                    <th colspan="3">{{ t("w_txt_psOffer_table_visibility_and_requests") }}</th>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_visibility_and_requests_feature_01") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_visibility_and_requests_feature_02") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>

                  <tr>
                    <td>{{ t("w_txt_psOffer_table_visibility_and_requests_feature_03") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_visibility_and_requests_feature_04") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_visibility_and_requests_feature_05") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>

                  <!-- ================= Devis ================= -->
                  <tr class="table-secondary">
                    <th colspan="3">{{ t("w_txt_psOffer_table_quotes") }}</th>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_quotes_feature_01") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_quotes_feature_02") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_quotes_feature_03") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_quotes_feature_04") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_quotes_feature_05") }} </td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_quotes_feature_06") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_quotes_feature_07") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_quotes_feature_08") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_quotes_feature_09") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_quotes_feature_10") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_quotes_feature_11") }}
                    </td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>

                  <!-- ================= Facturation ================= -->
                  <tr class="table-secondary">
                    <th colspan="3">{{ t("w_txt_psOffer_table_billing") }}</th>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_billing_feature_01") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_billing_feature_02") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_billing_feature_03") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_billing_feature_04") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_billing_feature_05") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_billing_feature_06") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_billing_feature_07") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_billing_feature_08") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_billing_feature_09") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_billing_feature_10") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <!-- ================= Lignes d’unité d’œuvre & OCR ================= -->
                  <tr class="table-secondary">
                    <th colspan="3">{{ t("w_txt_psOffer_table_lines") }}</th>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_lines_feature_01") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_lines_feature_02") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_lines_feature_03") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_lines_feature_04") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <!-- ================= Clients & chantiers ================= -->
                  <tr class="table-secondary">
                    <th colspan="3">{{ t("w_txt_psOffer_table_clients") }}</th>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_clients_feature_01") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_clients_feature_02") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_clients_feature_03") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_clients_feature_04") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_clients_feature_05") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_clients_feature_06") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <!-- ================= Suivi des paiements ================= -->
                  <tr class="table-secondary">
                    <th colspan="3">{{ t("w_txt_psOffer_table_payment") }}</th>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_payment_feature_01") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_payment_feature_02") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_payment_feature_03") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_payment_feature_04") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <!-- ================= Dépenses & URSSAF ================= -->
                  <tr class="table-secondary">
                    <th colspan="3">{{ t("w_txt_psOffer_table_expenses") }}</th>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_expenses_feature_01") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_expenses_feature_02") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_expenses_feature_03") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_expenses_feature_04") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_expenses_feature_05") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_expenses_feature_06") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <!-- ================= SAP (Service à la personne) ================= -->
                  <tr class="table-secondary">
                    <th colspan="3">{{ t("w_txt_psOffer_table_sap") }}</th>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_sap_feature_01") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_sap_feature_02") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_sap_feature_03") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_sap_feature_04") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <!-- ================= Exports & connecteurs comptabless ================= -->
                  <tr class="table-secondary">
                    <th colspan="3">{{ t("w_txt_psOffer_table_exports") }}</th>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_exports_feature_01") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_exports_feature_02") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_exports_feature_03") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_exports_feature_04") }} <img style="height: 20px;"
                      src="https://anecs.anecs-cjec.org/wp-content/uploads/sites/2/2024/01/logo-pennylane.png"
                      alt="Pennylane" /></td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_exports_feature_05") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <!-- ================= Notifications & communication ================= -->
                  <tr class="table-secondary">
                    <th colspan="3">{{ t("w_txt_psOffer_table_notifications") }}</th>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_notifications_feature_01") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_notifications_feature_02") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_notifications_feature_03") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_notifications_feature_04") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_notifications_feature_05") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_notifications_feature_06") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_notifications_feature_07") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <!-- ================= Compte & accès ================= -->
                  <tr class="table-secondary">
                    <th colspan="3">{{ t("w_txt_psOffer_table_account") }}</th>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_account_feature_01") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_account_feature_02") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_account_feature_03") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_account_feature_04") }}</td>
                    <td class="text-center">❌</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_account_feature_05") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_account_feature_06") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_account_feature_07") }}</td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                  <tr>
                    <td>{{ t("w_txt_psOffer_table_account_feature_08") }} </td>
                    <td class="text-center">✅</td>
                    <td class="text-center">✅</td>
                  </tr>
                </tbody>
              </table>
            </div>


          </div>
        </div>



      </div>

    </div>
  </section>

</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/main.css');

.nav-tabs {
  display: flex;
  justify-content: center;
}

.card-title-padding {
  padding-left: 50px;
  padding-right: 50px;
}

/* General tab styles */
.nav-tabs .nav-link {
  font-weight: bold;
  border: none;
  padding: 10px 15px;
}

/* Active tab styles */
.nav-tabs .nav-link:not(.active) {
  background-color: white !important;
  color: #49AFDA;
  border: 2px solid #49AFDA;
  border-radius: 10px;
  font-size: 14px !important;
  padding-left: 20px;
  padding-right: 20px;

}

/* Inactive tab styles */
.nav-tabs .nav-link.active {
  color: white !important;
  background-color: #49AFDA !important;
  border-radius: 10px;
  font-size: 14px;
  border: 2px solid #49AFDA;
  padding-left: 20px;
  padding-right: 20px;
}

.nav-tabs .nav-link::after {
  content: none !important;
}

/*****************************************/
.choose-offer-padding {
  padding-left: 50px;
  padding-right: 50px;
}

.hr-separator {
  border-color: #dee2e6;
  border-width: 2px;
  border-style: solid;
  margin-top: 10px;
  margin-bottom: 10px;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.feature-item-free {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.notice {
  font-size: 10px;
}

.container-custum-padding {
  padding-left: 10px;
  padding-right: 20px
}

ul p {
  line-height: 1.5;
}

/***********cards part**************************/
.cards-container {
  display: flex;
  gap: 30px;
  margin-top: 2rem;
}

.card {
  width: 40% !important;
  padding: 1.5rem;
  background-color: white;
  border: 0px solid #ddd;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.card-mobile {
  width: 90% !important;
  padding: 1.5rem;
  background-color: white;
  border: 0px solid #ddd;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  margin-left: 20px;
  margin-right: 20px;
}

.offer-title {
  font-size: 2rem;
  line-height: 1.2;
  font-weight: bold;
  color: #333;
}



.present-img {
  margin-left: "500px !important";
}

.price {
  font-size: 2rem;
  font-weight: bold;
  color: #00b5db;
  text-align: center !important;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  padding: 0.5rem 0;
  font-size: 0.95rem;
  color: #555;
  margin: 0px;
}

li:last-child {
  border-bottom: none;
}

/* Small devices (sm) - 576px and up */
@media (min-width: 576px) {

  /* Styles for small screens */
  .cards-container {
    gap: 5px !important;
  }
}

/* Medium devices (md) - 768px and up */
@media (min-width: 768px) {

  /* Styles for medium screens */
  .container-custum-padding {
    padding-left: 100px !important;
    padding-right: 200px !important;
  }

  .card {
    width: 360px !important;
    /*width: 45% !important; */
  }

  .cards-container {
    gap: 15px !important;
  }

}

/* Large devices (lg) - 992px and up */
@media (min-width: 850px) {

  /* Styles for large screens */
  .card {
    width: 400px !important;
    /*width: 35% !important; */
  }

  .cards-container {
    gap: 30px !important;
  }
}

.bg-dark-blue {
  background-color: #233648 !important;
}
</style>
